module.exports = __webpack_public_path__ + "img/sample_bg_02.466cda90.jpg";